import { useCallback, useEffect, useState } from 'react'

const SEARCH_INPUT_DEBOUNCE_MS = 250

/**
 * The search box's text, and the query it settles into once typing pauses;
 * `initial` is what it opens with (searched at once).
 */
export function useSearchInput(initial = '') {
  const [input, setInput] = useState(initial)
  const [query, setQuery] = useState(initial)

  useEffect(() => {
    const timer = setTimeout(() => setQuery(input), SEARCH_INPUT_DEBOUNCE_MS)
    return () => clearTimeout(timer)
  }, [input])

  /** Empties the box and the query at once, without waiting for the debounce. */
  const clear = useCallback(() => {
    setInput('')
    setQuery('')
  }, [])

  return { input, query, setInput, clear }
}
